import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import BuyTab from "./BuyTab";

function CustomQueries () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <BuyTab />
      <Footer />
    </DashboardLayout>
  );
}

export default CustomQueries;
